import { styled } from '@mui/material/styles';

export const ReplyActionWrapper = styled('div')`
  visibility: hidden;
  display: flex;
  align-items: center;
`;
